(function () {
  var bar = document.querySelector('.room33-sticky[data-target]'); if (!bar) return;
  function tick(){var t=Date.parse(bar.getAttribute('data-target'));if(isNaN(t))return;var d=Math.max(0,t-Date.now());var s=function(k,v){var n=bar.querySelector('[data-unit="'+k+'"]');if(n)n.textContent=('0'+v).slice(-2);};s('days',Math.floor(d/86400000));s('hrs',Math.floor((d%86400000)/3600000));s('min',Math.floor((d%3600000)/60000));s('sec',Math.floor((d%60000)/1000));}
  tick(); setInterval(tick, 1000);
  function onScroll(){ if (window.scrollY > 700) bar.classList.add('is-visible'); else bar.classList.remove('is-visible'); }
  addEventListener('scroll', onScroll, { passive: true }); onScroll();

  document.addEventListener('click', function (e) {
  const btn = e.target.closest('#sticky_add_to_cart');
  if (!btn) return;

  const form = document.querySelector('.room33-reply__form');
  if (!form) return;

  e.preventDefault();
  form.requestSubmit ? form.requestSubmit() : form.submit();
});

})();
